
// to connect index.html. Main JS file

import React  from "react";
import ReactDom from "react-dom";
import App from './App'  // functional component
// we cannot use LINK outside of react-router-dom , so we make use of browser router 

import { BrowserRouter as Router } from "react-router-dom";

import './global.css';
import { ResultContextProvider } from './context/ResultContextProvider' 
// we need to wrap render with context info. Otherwise will get Cannot destructure property 'results' of '(0 , _context_ResultContextProvider__WEBPACK_IMPORTED_MODULE_2__.useResultContext)(...)' as it is undefined.

ReactDom.render
(
    <ResultContextProvider>
        <Router>
             <App/>
         </Router>
    </ResultContextProvider>,
document.getElementById('root'));